import Icon from 'veui/components/Icon'
import { IconAbTest } from 'dls-icons-vue'

Icon.register('ab-test', IconAbTest)
